export const hasTranslationsLoaded = (translation: { [key: string]: string }): boolean =>
  Object.keys(translation || {}).some(key => translation[key] !== '');

export const translationChanged = (translation: { [key: string]: string },
  prevTranslation: { [key: string]: string }): boolean =>
  (!translation && !!prevTranslation) ||
  (!!translation && !prevTranslation) ||
  Object.keys(translation || {}).some(key => translation[key] !== (prevTranslation || {})[key]);
